import {translationBaseKey} from '../decorators/translation-base-key.decorator';
import {LicenseTypeEnum} from '../enums/license-type.enum';
import {IsEnum} from '@pristine-ts/class-validator';
import {advancedFormControl, FormControlTypeEnum} from "@magieno/common";

@translationBaseKey('calculate-subscription')
export class CalculateSubscriptionOptions {
  @advancedFormControl({
    type: FormControlTypeEnum.Input
  })
  @IsEnum(LicenseTypeEnum)
  licenseType: LicenseTypeEnum;
}